module.exports = __webpack_public_path__ + "img/logo.75e7187d.png";